import { createFileRoute } from "@tanstack/react-router"

import { blogPosts } from "@/lib/blog-posts"
import { RSS_FEED_LINK } from "@/lib/rss-meta"
import { seoMeta } from "@/lib/seo"

import type { BlogSearch } from "./-components/blogHelpers"
import { BlogIndexPage } from "./-components/BlogIndexPage"

export const Route = createFileRoute("/_content/blog/")({
  validateSearch: (search: Record<string, unknown>): BlogSearch => ({
    category: typeof search["category"] === "string" ? search["category"] : undefined,
  }),
  head: () =>
    seoMeta({
      title: "Blog",
      description: "News, updates, and stories from the Entire team.",
      url: "https://entire.com/blog",
      image: "https://entire.com/images/og/blog.png",
      extraLinks: [RSS_FEED_LINK],
    }),
  component: BlogListPage,
})

function BlogListPage() {
  const search = Route.useSearch()

  return <BlogIndexPage posts={blogPosts} selectedCategory={search.category} />
}
